import { CloudImage } from '@components/CloudImage';
import styled from 'styled-components';

const IMAGE_MAX_WIDTH = '346px';
const IMAGE_MAX_HEIGHT = '60px';

export const StyledCloudImage = styled(CloudImage)`
  max-height: ${IMAGE_MAX_HEIGHT};
  max-width: min(75%, ${IMAGE_MAX_WIDTH});
`;
